import { zodResolver } from '@hookform/resolvers/zod'
import { DialogActions, DialogContent, DialogTitle, Grid, Stack, Typography } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { Button, ControlledTextField } from 'src/components/forms'
import { EntityWithIdFields } from 'src/types'
import { z } from 'zod'
import { ClienteSubTipoDTO, ClienteSubTipoFields } from './types'
import { HttpClienteSubTipo } from './api'

type Props = {
    item?: ClienteSubTipoDTO
    onClose: () => void
}

const schema = z.object({
    [ClienteSubTipoFields.Descripcion]: z.string().min(1, 'Requerido')
})

type FormData = z.infer<typeof schema>

function EditClienteSubTipoForm({ item, onClose }: Props) {
    const isNew = !item

    const { control, handleSubmit } = useForm<FormData>({
        resolver: zodResolver(schema),
        defaultValues: isNew ? { [ClienteSubTipoFields.Descripcion]: '' } : { [ClienteSubTipoFields.Descripcion]: item[ClienteSubTipoFields.Descripcion] }
    })

    const onSubmitWrapper = () => {
        let mensajeError = 'No se pudo guardar'

        const promise = new Promise<void>((resolve, reject) => {
            handleSubmit(formData => {
                const request = isNew
                    ? HttpClienteSubTipo.insert(formData)
                    : HttpClienteSubTipo.update(item![EntityWithIdFields.Id], formData)

                request.then(() => { setTimeout(onClose, 500); resolve() }).catch(reject)
            }, () => { mensajeError = 'Revise el formulario'; reject(mensajeError) })()
        })

        toast.promise(promise, { success: 'Guardado', error: () => mensajeError, loading: 'Guardando' })
        return promise
    }

    return (
        <>
            <DialogTitle sx={{ pb: 0 }}>
                <Stack direction='row' spacing={1.5} alignItems='center'>
                    <EditIcon color='primary' />
                    <Typography variant='h6' fontWeight={600}>
                        {isNew ? 'Nuevo subtipo de cliente' : 'Editar subtipo de cliente'}
                    </Typography>
                </Stack>
            </DialogTitle>
            <DialogContent sx={{ pt: '24px !important', px: 5, pb: 4 }}>
                <Grid container spacing={4}>
                    <Grid item xs={12}>
                        <ControlledTextField control={control} name={ClienteSubTipoFields.Descripcion} label='Descripción' fullWidth />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button variant='text' color='inherit' onClick={onClose}>Cancelar</Button>
                <Button variant='contained' color='primary' promise={onSubmitWrapper}>Guardar</Button>
            </DialogActions>
        </>
    )
}

export default EditClienteSubTipoForm
